// src/pages/HomePage.jsx

import React from 'react';
import AnimatedBackground from '@/components/AnimatedBackground';
import HeroSection from '@/components/HeroSection';
import AdFormatsSection from '@/components/AdFormatsSection';
import FeaturesSection from '@/components/FeaturesSection';
import TrafficStatisticsSection from '@/components/TrafficStatisticsSection';
import FaqSection from '@/components/FaqSection';

const HomePage = () => {
  return (
    <div className="relative min-h-screen overflow-hidden">
      {/* 背景特效 */}
      <AnimatedBackground />

      {/* 页面主体内容 */}
      <div className="relative z-10 space-y-24 md:space-y-32 lg:space-y-40">
        <HeroSection />
        <AdFormatsSection />
        <FeaturesSection />
        <TrafficStatisticsSection />
        <FaqSection />
      </div>
    </div>
  );
};

export default HomePage;
